import React from 'react';
import { searchClient } from '@services/businessContainer';
import { Configure, InstantSearch } from 'react-instantsearch-core';
import Hits from './Hits';
import getConfig from 'next/config';
import { useFrequentlyBoughtProducts } from '@hooks/businessContainer';
import { IPrismicRichText } from '@monofront/types';
import { useAuthentication } from '@context/businessContainer';
import {
  generateProductIndexName,
  getChannelFromLocale,
} from '@monofront/business/utils';
import { ALGOLIA_PRODUCT_SORT_BY } from '@monofront/business/constants';
import { useRouter } from 'next/router';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapFrequentlyBoughtProductsCarousel } from './mapFrequentlyBoughtProductsCarousel';

const {
  publicRuntimeConfig: { algoliaConfig },
} = getConfig();

export interface IFrequentlyBoughtProductsCarousel {
  primary: {
    title: IPrismicRichText;
    blockName: string;
  };
  position: number;
}

const FrequentlyBoughtProductsCarousel: React.FC<
  IFrequentlyBoughtProductsCarousel
> = ({ primary, position }) => {
  const { customSort, customerFilter } = useFrequentlyBoughtProducts({
    limit: 25,
  });
  const { locale } = useRouter();
  const { customer } = useAuthentication();

  if (!customer?.totalOrderPaid) {
    return null;
  }

  return (
    <InstantSearch
      indexName={generateProductIndexName(
        algoliaConfig.environment,
        false,
        getChannelFromLocale(locale),
        false,
        ALGOLIA_PRODUCT_SORT_BY.POPULARITY,
      )}
      searchClient={searchClient}
    >
      <Hits
        customSort={customSort}
        title={primary.title}
        position={position}
        blockName={primary.blockName}
      />
      <Configure filters={customerFilter} />
    </InstantSearch>
  );
};

export default withSlice(
  FrequentlyBoughtProductsCarousel,
  mapFrequentlyBoughtProductsCarousel,
);
